export type RequirementType =
    | 'numeric'
    | 'lowercase'
    | 'uppercase'
    | 'special'
    | 'length'
    | 'all'
    | 'pseudoNotIDNPattern'
    | 'pseudoNumericPattern'
    | 'pseudoPattern'
    | 'latinPattern'
    | 'surnamePattern'
    | 'cityPattern'
    | 'email'
    | 'frenchPhone'
    | 'url'
    | 'zipCode';

export const validationMap: Record<RequirementType, (value: string) => boolean> = {
  lowercase: (value) => /[a-z]/.test(value),
  uppercase: (value) => /[A-Z]/.test(value),
  special: (value) => /[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/g.test(value),
  numeric: (value) => /[0-9]/.test(value),
  length: (value) => value.length > 11,
  all: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value) && validationMap.special(value) && /[0-9]/.test(value) && value.length > 11,
  pseudoNotIDNPattern: (value) => /[iI][dD][nN]|.*[iI][dD][nN]\\d{3}.*/.test(value),
  pseudoNumericPattern: (value) => /\D\d{5,8}\D?|\D?\d{5,8}\D/.test(value),
  pseudoPattern: (value) => /^[a-zA-Z0-9\\.\\-_]{6,}$/.test(value),
  latinPattern: (value) => /\D+/.test(value),
  surnamePattern: (value) => /^[^ \\.'\\-]+[^\\.]*[^ \\.'\\-]+$/.test(value),
  cityPattern: (value) => /^([^0-9]*?( [0-9AB]{2,3})?)( *\\([0-9AB]+\\))?$/.test(value),
  email: (value) => /[\w.%+-]+@[\w.-]+\.[A-Za-z]+$/.test(value),
  frenchPhone: (value) => /(\+?33|0) ?\d ?(\d\d ?){4} *$/.test(value),
  url: (value) => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\\.-]+)+[\w\-\\._~:/?#[\]@!\\$&'\\(\\)\\*\\+,;=.]+$/.test(value),
  zipCode: (value) => /^[0-9]{5}$/.test(value),
};
